// extracted by mini-css-extract-plugin
export default {"img-fluid":"nuDGA","img-thumbnail":"Mvv7L","figure":"_6VH+z","figure-img":"UcVcf","figure-caption":"sAEy6"};